// extracted by mini-css-extract-plugin
export var hideEditor = "_mm-2";
export var infoIcon = "_mm-3";
export var label = "_mm-1";
export var labelContainer = "_mm-0";
export var readonlyText = "_mm-4";